import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class JwtInterceptor implements  HttpInterceptor {
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const user = JSON.parse(localStorage.getItem('currentUser') || 'null');
    if (user && user.token) {
      // Never attach our own Authorization header to a direct-to-S3 request (presigned
      // upload/download URLs) - S3 rejects a request that carries BOTH a presigned-URL
      // signature AND an Authorization header ("Only one auth mechanism allowed").
      const isS3Request = request.url.includes('amazonaws.com');
      if (!isS3Request) {
        request = request.clone({
          setHeaders: {
            Authorization: 'Bearer ' + user.token,
          },
        });
      }

    }

    return next.handle(request);
  }
}
